<template>
  <div class="deground">
    <headerpage :status="3"></headerpage>
    <div class="adaptation" style="background-color: #f6f8f7;">
      <!--      <div class="hetext">首页>园区企业>详情</div>-->
      <div v-if="detail" class="flex justify-between">
        <div class="cleft">
          <div class="bg-white margin-bottom-20 box-shadow border-radius-10" style="padding: 20px;">
            <div class="flex justify-between padding-left-12 " style="margin-bottom: 12px;">
              <div class="company_logo" style="width: 115px;height: 115px;">
                <avatar-view :size="115" fontSize="32" mod="big" :name="detail.company_name"></avatar-view>
              </div>
              <div class="comright flex justify-between align-center">
                <div class="bott">
                  <div class="comname" style="margin: 0">
                    {{ detail.company_name }}
                    <copy-btn :text="detail.company_name"></copy-btn>
                  </div>
                  <div class="margin-top-15">
                    <el-tag class="bg-blueFF margin-right-8" effect="dark" size="small "
                        v-if="detail.operate_status">
                      {{ detail.operate_status }}
                    </el-tag>
                    <template v-if="detail.show.length">
                      <el-tag class="bg-blueFF margin-right-8" effect="dark" size="small "
                          v-for="(item,index) in detail.show" :key="index">
                        {{ item }}
                      </el-tag>
                    </template>
                  </div>
                  <div class="margin-top-15 timetext">
                    <img class="icon" src="../../assets/images/icon7.png"/>
                    {{ dayjs(Number(detail.updatetime) * 1000).format('YYYY-MM-DD') }} 更新
                  </div>
                </div>
                <!-- <div>
                  <el-button @click="addmysystem"
                    style="width: 168px;border: solid 1px #5568e8;color: #386af6;font-size: 17px;"
                    size="small">+加入筛选系统</el-button>
                </div> -->
              </div>
            </div>
            <div class="gray-tag" style="font-size: 14px;">
              <span
                  v-if="detail.city_str">#{{ detail.city_str }}</span><span
                v-if="detail.district_str">#{{ detail.district_str }}</span>
            </div>

            <div style=" padding: 12px;border-radius: 4px;">
              <div class="flex align-center margin-bottom-8">
                <div class="fivewidth newmar text-cut">
                  <span class="lefttag">法定代表人：</span>
                  <span class="righttag" style="word-break: break-all;">{{ detail.legal ? detail.legal : '--' }}
                  </span>
                  <copy-btn :text="detail.legal"></copy-btn>
                </div>
                <div class="fivewidth newmar text-cut">
                  <span class="lefttag">邮箱：</span>
                  <span class="righttag">{{ emaillist.length ? emaillist[0] : '--' }}</span>
                  <template v-if="emaillist.length">
                    <el-dropdown>
                      <span style="color:#3290FD;cursor: pointer;">查看更多</span>
                      <el-dropdown-menu slot="dropdown">
                        <template v-for="(item,index) in emaillist">
                          <el-dropdown-item>{{ item }}
                            <copy-btn :text="item"></copy-btn>
                          </el-dropdown-item>
                        </template>
                      </el-dropdown-menu>
                    </el-dropdown>
                    <copy-btn :text="emaillist[0]"></copy-btn>
                  </template>
                </div>
              </div>
              <div class="flex align-center margin-bottom-8">
                <div class="fivewidth newmar text-cut">
                  <span class="lefttag">统一社会信用代码：</span>
                  <span class="righttag">{{ detail.code ? detail.code : '--' }}</span>
                  <copy-btn :text="detail.code"></copy-btn>
                </div>
                <div class="fivewidth newmar  flex">
                  <span class="lefttag" style="">地址：</span>
                  <div class="righttag" :class="{'text-cut':!showAddress}" id="addressbox"
                      style="max-width: 380px;width: auto;">
                    {{ detail.new_address ? detail.new_address : '--' }}
                    <span class="cpoint" v-if="showAddress&&detail.new_address.length>24" @click="showAddress = false"
                        style="width: 40px; color: rgb(57, 129, 244);font-size: 15px;">收起</span>

                    <copy-btn :text="detail.new_address"></copy-btn>
                  </div>

                  <p class="cpoint" v-if="!showAddress&&detail.new_address.length>24" @click="showAddress = true"
                      style="color: rgb(57, 129, 244);font-size: 16px;margin-left: 1%;">更多</p>
                </div>
              </div>
              <!-- <div class="flex align-center margin-bottom-8">
                <div class="fivewidth newmar text-cut">
                  <span class="lefttag">注册资本：</span>
                  <span class="righttag">{{detail.capital ? detail.capital : '--'}}</span>
                  <copy-btn :text="detail.capital"></copy-btn>
                </div>
              </div> -->
              <div class="flex align-center margin-bottom-8">
                <div class="fivewidth newmar text-cut">
                  <span class="lefttag">电话：</span>
                  <template v-if="detail.phone">
                    <template>
                      <template v-for="(item,index) in phonelist">
                        <span class="righttag" :key="item" v-if="index<3">{{ item }} </span>
                        <span v-if="index!=phonelist.length-1&&index<2">,</span>
                      </template>
                    </template>
                    <copy-btn :text="detail.phone"></copy-btn>
                  </template>
                  <span v-else class="righttag" style="word-break: break-all;">--</span>
                </div>
                <div class="fivewidth newmar text-cut">
                  <span class="lefttag">网址：</span>
                  <span class="righttag" style="color: #3290FD;cursor: pointer; "
                      @click="openWeb(detail.web)">{{ detail.web ? detail.web : '暂无网址' }}</span>
                  <!-- <copy-btn :text="detail.web"></copy-btn> -->
                </div>
              </div>

              <div class="flex justify-start align-center" style="margin-bottom: 8px;">
                <div class="flex justify-start align-start" style="width: 100%;">
                  <div class="lefttag">简介：</div>
                  <div class="righttag2" id="righttag2" :class="showall ? '':'text-cut'" style="max-width: 882px;">
                    {{ detail.business }}
                    <span class="cpoint" v-if="showall" @click="showall = false"
                        style="width: 40px; color: rgb(57, 129, 244);font-size: 14px;">收起</span>
                  </div>
                  <p class="cpoint" v-if="!showall" @click="showall = true"
                      style="color: rgb(57, 129, 244);font-size: 14px;margin-left: 1%;">更多</p>
                </div>
              </div>
            </div>

          </div>

          <div class="box-shadow bg-white">
            <div class="cnt-box">
              <div class="boxt">
                <div class="boxt_cent" @click="tppindex = 0" :class="tppindex==0?'boxtsty':''">
                  政策信息
                </div>
                <div class="boxt_cent" @click="tppindex = 1" :class="tppindex==1?'boxtsty':''">
                  基本信息
                </div>
                <div class="boxt_cent" @click="tppindex = 2" :class="tppindex==2?'boxtsty':''">
                  联系方式 <span>({{ numberData['a2'] || 0 }})</span>
                </div>
                <div class="boxt_cent" @click="tppindex = 3" :class="tppindex==3?'boxtsty':''">
                  知识产权 <span>({{ numberData['a3'] || 0 }})</span>
                </div>
                <div class="boxt_cent" @click="tppindex = 4" :class="tppindex==4?'boxtsty':''">
                  资质证书 <span>({{ numberData['a4'] || 0 }})</span>
                </div>
                <div class="boxt_cent" @click="tppindex = 5" :class="tppindex==5?'boxtsty':''">
                  招投标 <span>({{ numberData['a5'] || 0 }})</span>
                </div>
                <div class="boxt_cent" @click="tppindex = 6" :class="tppindex==6?'boxtsty':''">
                  经营异常 <span>({{ numberData['a6'] || 0 }})</span>
                </div>
                <div class="boxt_cent" @click="tppindex = 7" :class="tppindex==7?'boxtsty':''">
                  司法信息 <span>({{ numberData['a7'] || 0 }})</span>
                </div>
                <div style="width: 40px;"></div>
              </div>
              <!-- lazy -->
              <el-tabs class="detail-tabs" :value="'tppindex'+tppindex" type="card"
                  @tab-click="handleClick">
                <el-tab-pane name="tppindex0" lazy>
                  <policy-page :id="id"></policy-page>
                </el-tab-pane>
                <el-tab-pane name="tppindex1" lazy>
                  <detail-page :id="id" :detail="detail"></detail-page>
                </el-tab-pane>
                <el-tab-pane name="tppindex2" lazy>
                  <contract-page :id="id" :detail="detail">
                  </contract-page>
                </el-tab-pane>
                <el-tab-pane name="tppindex3" lazy>
                  <intellectual-page :id="id" :detail="detail">
                  </intellectual-page>
                </el-tab-pane>
                <el-tab-pane name="tppindex4" lazy>
                  <certificate-page :id="id" :detail="detail">
                  </certificate-page>
                </el-tab-pane>
                <el-tab-pane name="tppindex5" lazy>
                  <tender-page :id="id" :detail="detail"></tender-page>
                </el-tab-pane>
                <el-tab-pane name="tppindex6" lazy>
                  <abnormal-page :id="id" :detail="detail">
                  </abnormal-page>
                </el-tab-pane>
                <el-tab-pane name="tppindex7" lazy>
                  <judicial-page :id="id" :detail="detail">
                  </judicial-page>
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
        </div>
<!--        <div class="cright margin-left-10">-->
<!--          <company-card type="1" :id="id" :industry="detail.industry"></company-card>-->
<!--          <div>-->
<!--            <div class="bg-white" style="border-radius: 10px;" v-if="common.rightSidebar">-->
<!--              <div class="box1_header" style="border-bottom: none;">-->
<!--                <div class="box1_header_shu"></div>-->
<!--                <div class="box1_header_text">服务推荐</div>-->
<!--              </div>-->
<!--              <div>-->
<!--                <div class="likeone1" v-for="(item, index) in advertiselist" :key="index" @click="tonext(item.href)">-->
<!--                  <div class="oneleft1">-->
<!--                    <img :src="item.pic | addurl" alt="">-->
<!--                  </div>-->
<!--                  <div class="oneright1">-->
<!--                    <div class="text-cut text-center" style="font-size: 18px;width: 100%;">-->
<!--                      {{ item.title }}-->
<!--                    </div>-->
<!--                    &lt;!&ndash; <div class="text-cut2" style="font-size: 14px;color: #999999;">{{item.detail}}</div> &ndash;&gt;-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
      </div>

      <div style="height: 30px;"></div>
    </div>

    <el-dialog :title="showone.name" :visible.sync="showimg">
      <table id="table" class="table">
        <tr>
          <td class="label">证书名称</td>
          <td class="value">{{ showone.name }}</td>
        </tr>
        <tr>
          <td class="label">证书编号</td>
          <td class="value">{{ showone.number }}</td>
        </tr>
        <tr>
          <td class="label">证书状态</td>
          <td class="value">{{ showone.status == 0 ? '无效' : '有效' }}</td>
        </tr>
        <tr>
          <td class="label">发证日期</td>
          <td class="value">{{ showone.date }}</td>
        </tr>
      </table>
    </el-dialog>

  </div>
</template>

<script>
import companyCard from "@/components/company/recommend"
import headerpage from '../../components/header/header.vue';
import policyPage from "./components/policy-page"
import detailPage from "./components/detail-page"
import contractPage from "./components/contract-page"
import intellectualPage from "./components/intellectual-page"
import certificatePage from "./components/certificate-page"
import tenderPage from "./components/tender-page"
import abnormalPage from "./components/abnormal-page"
import judicialPage from "./components/judicial-page"
import dayjs from "dayjs"

export default {
  components: {
    "company-card": companyCard,
    headerpage,
    policyPage,
    detailPage,
    contractPage,
    intellectualPage,
    certificatePage,
    tenderPage,
    abnormalPage,
    judicialPage
  },
  data() {
    return {

      tppindex: 0, // index 下标
      detail: '',
      id: '',
      keyword: '',
      showall: false,
      show: false,
      showimg: false,
      showone: '',
      likelist: [],
      token: '',
      systeminfo: '',
      advertiselist: [],

      newlist: [],
      supporttotal_money: 0,
      com: [{
        totalnum: 0,
        currentPage: 1,
        pagesize: 15,
        type: 0
      }, {
        totalnum: 0,
        currentPage: 1,
        pagesize: 8,
        type: 1
      }, {
        totalnum: 0,
        currentPage: 1,
        pagesize: 8,
        type: 2
      }, {
        totalnum: 0,
        currentPage: 1,
        pagesize: 8,
        type: 3
      }, {
        totalnum: 0,
        currentPage: 1,
        pagesize: 8,
        type: 4
      }, {
        totalnum: 0,
        currentPage: 1,
        pagesize: 8,
        type: 5
      }, {
        totalnum: 0,
        currentPage: 1,
        pagesize: 8,
        type: 6
      }, {
        totalnum: 0,
        currentPage: 1,
        pagesize: 8,
        type: 7
      }, {
        totalnum: 0,
        currentPage: 1,
        pagesize: 8,
        type: 8
      }, {
        totalnum: 0,
        currentPage: 1,
        pagesize: 8,
        type: 9
      }, {
        totalnum: 0,
        currentPage: 1,
        pagesize: 8,
        type: 10
      }],
      people_list: [], //主要人员  1
      shareholder: [], //股东信息  2
      change_record: [], //变更记录  3
      qualification_list: [], // 资质证书 4
      seniority_list: [], // 资质资格列表 5
      brand_list: [], // 商标信息 6
      patent_list: [], //专利信息 7
      softright_list: [], // 软件著作权 8
      copyright_list: [], // 作品著作权 9
      webregister_list: [], //网站备案列表 10
      common: '',
      activeName: "",
      numList: {},
      Loading: false,
      numberData: {},
      showOpen: false,
      showAddress: false,
      showAddressOpen: false
    }
  },
  computed: {
    emaillist() {
      let list = []
      if (this.detail && this.detail.email) {
        list = this.detail.email.split(",")
      }
      return list
    },
    phonelist() {
      let list = []
      if (this.detail && this.detail.phone) {
        list = this.detail.phone.split(",")
      }
      return list
    },
  },
  methods: {
    dayjs,
    tologin() {
      this.$router.push({
        path: '/login',
      });
    },
    handleClick() {

    },
    handleCurrentChange: function (currentPage, index) {
      this.com[index].currentPage = currentPage;
      // console.log(this.currentPage)  //点击第几页
      // this.rightlist = [];
      switch (index) {
        case 0:
          this.getnewlist();
          break;
        case 1:
          this.getpeoplelist();
          break;
        case 2:
          this.getshare();
          break;
        case 3:
          this.getchange();
          break;
        case 4:
          this.getqua();
          break;
        case 5:
          this.getseniority();
          break;
        case 6:
          this.getbrand();
          break;
        case 7:
          this.getpatent();
          break;
        case 8:
          this.getsoftright();
          break;
        case 9:
          this.getcopyright();
          break;
        case 10:
          this.getweb();
          break;

      }

    },
    getqua() {
      //enterprise_support
      var api = this.$api.api.index.qualification_list;
      this.$https.post(
          {
            api: api,
            type: "formData",
          },
          {
            page: this.com[4].currentPage,
            page_size: this.com[4].pagesize,
            id: this.id
          },
          (response) => {
            console.log("response", response);
            if (response.data.length) {
              for (let i in response.data) {
                if (response.data[i].href) {
                  if (response.data[i].href.indexOf("http") == -1) {
                    response.data[i].href = 'http://' + response.data[i].href;
                  }
                }
              }
            }
            this.qualification_list = response.data;
            this.com[4].totalnum = response.count;
          },
          (error) => {
            console.log(error);
          }
      );
    },
    getnewlist() {
      //enterprise_support
      var api = this.$api.api.index.enterprise_support;
      this.$https.post(
          {
            api: api,
            type: "formData",
          },
          {
            page: this.com[0].currentPage,
            page_size: this.com[0].pagesize,
            id: this.id
          },
          (response) => {
            console.log("response", response);

            response.data.policy_support.forEach(item => {
              item['showz'] = false;
              // !item.support &&
              if (!item.province_support && !item.city_support && !item.area_support) {
                item['showz'] = true;
              }
            });
            this.supporttotal_money = response.data.total_money;
            this.newlist = response.data.policy_support;
            this.com[0].totalnum = response.count;
          },
          (error) => {
            console.log(error);
          }
      );
    },
    getpeoplelist() {
      //enterprise_support
      var api = this.$api.api.index.majorpeople_list;
      this.$https.post(
          {
            api: api,
            type: "formData",
          },
          {
            page: this.com[1].currentPage,
            page_size: this.com[1].pagesize,
            id: this.id
          },
          (response) => {
            console.log("response", response);

            this.people_list = response.data;
            this.com[1].totalnum = response.count;
          },
          (error) => {
            console.log(error);
          }
      );
    },
    getshare() {
      //enterprise_support
      var api = this.$api.api.index.shareholder_list;
      this.$https.post(
          {
            api: api,
            type: "formData",
          },
          {
            page: this.com[2].currentPage,
            page_size: this.com[2].pagesize,
            id: this.id
          },
          (response) => {
            console.log("response", response);

            this.shareholder = response.data;
            this.com[2].totalnum = response.count;
          },
          (error) => {
            console.log(error);
          }
      );
    },
    getchange() {
      //enterprise_support
      var api = this.$api.api.index.change_list;
      this.$https.post(
          {
            api: api,
            type: "formData",
          },
          {
            page: this.com[3].currentPage,
            page_size: this.com[3].pagesize,
            id: this.id
          },
          (response) => {
            console.log("response", response);

            this.change_record = response.data;
            this.com[3].totalnum = response.count;
          },
          (error) => {
            console.log(error);
          }
      );
    },


    getdetail() {
      var api = this.$api.api.index.enterprise_detail;

      const loading = this.$loading({
        lock: true,
        text: '正在加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0)'
      });
      this.$https.post(
          {
            api: api,
            type: "formData",
          },
          {
            id: this.id
          },
          (response) => {
            loading.close();
            console.log("response", response);
            if (response.data.policy_support) {
              if (response.data.policy_support.length) {
                for (let i in response.data.policy_support) {
                  if (response.data.policy_support[i].href) {
                    if (response.data.policy_support[i].href.indexOf("http") == -1) {
                      response.data.policy_support[i].href = 'http://' + response.data.policy_support[i].href;
                    }
                  }
                }
              }
            }
            if (response.data.brand) {
              if (response.data.brand.length) {
                for (let i in response.data.brand) {
                  if (response.data.brand[i].href) {
                    if (response.data.brand[i].href.indexOf("http") == -1) {
                      response.data.brand[i].href = 'http://' + response.data.brand[i].href;
                    }
                  }
                }
              }
            }

            if (response.data.copyright) {
              if (response.data.copyright.length) {
                for (let i in response.data.copyright) {
                  if (response.data.copyright[i].href) {
                    if (response.data.copyright[i].href.indexOf("http") == -1) {
                      response.data.copyright[i].href = 'http://' + response.data.copyright[i].href;
                    }
                  }
                }
              }
            }

            if (response.data.patent) {
              if (response.data.patent.length) {
                for (let i in response.data.patent) {
                  if (response.data.patent[i].href) {
                    if (response.data.patent[i].href.indexOf("http") == -1) {
                      response.data.patent[i].href = 'http://' + response.data.patent[i].href;
                    }
                  }
                }
              }
            }

            if (response.data.qualification) {
              if (response.data.qualification.length) {
                for (let i in response.data.qualification) {
                  if (response.data.qualification[i].href) {
                    if (response.data.qualification[i].href.indexOf("http") == -1) {
                      response.data.qualification[i].href = 'http://' + response.data.qualification[i].href;
                    }
                  }
                }
              }
            }

            this.detail = response.data;
          },
          (error) => {
            loading.close();
            console.log(error);
          }
      );
    },
    handleSizeChange(size) {
      // this.pagesize = size;
      // console.log(size); //每页下拉显示数据
    },
    getpatent() {
      var api = this.$api.api.index.patent_list;
      this.$https.post(
          {
            api: api,
            type: "formData",
          },
          {
            page: this.com[7].currentPage,
            page_size: this.com[7].pagesize,
            id: this.id
          },
          (response) => {
            console.log("response", response);
            if (response.data.length) {
              for (let i in response.data) {
                if (response.data[i].href) {
                  if (response.data[i].href.indexOf("http") == -1) {
                    response.data[i].href = 'http://' + response.data[i].href;
                  }
                }
              }
            }
            this.patent_list = response.data;
            this.com[7].totalnum = response.count;
          },
          (error) => {
            console.log(error);
          }
      );
    },
    getbrand() {
      var api = this.$api.api.index.brand_list;
      this.$https.post(
          {
            api: api,
            type: "formData",
          },
          {
            page: this.com[6].currentPage,
            page_size: this.com[6].pagesize,
            id: this.id
          },
          (response) => {
            console.log("response", response);
            if (response.data.length) {
              for (let i in response.data) {
                if (response.data[i].href) {
                  if (response.data[i].href.indexOf("http") == -1) {
                    response.data[i].href = 'http://' + response.data[i].href;
                  }
                }
              }
            }

            this.brand_list = response.data;
            this.com[6].totalnum = response.count;
          },
          (error) => {
            console.log(error);
          }
      );
    },
    getcopyright() {
      var api = this.$api.api.index.copyright_list;
      this.$https.post(
          {
            api: api,
            type: "formData",
          },
          {
            page: this.com[9].currentPage,
            page_size: this.com[9].pagesize,
            id: this.id
          },
          (response) => {
            console.log("response", response);
            if (response.data.length) {
              for (let i in response.data) {
                if (response.data[i].href) {
                  if (response.data[i].href.indexOf("http") == -1) {
                    response.data[i].href = 'http://' + response.data[i].href;
                  }
                }
              }
            }
            this.copyright_list = response.data;
            this.com[9].totalnum = response.count;
          },
          (error) => {
            console.log(error);
          }
      );
    },
    getsoftright() {
      var api = this.$api.api.index.softright_list;
      this.$https.post(
          {
            api: api,
            type: "formData",
          },
          {
            page: this.com[8].currentPage,
            page_size: this.com[8].pagesize,
            id: this.id
          },
          (response) => {
            console.log("response", response);

            this.softright_list = response.data;
            this.com[8].totalnum = response.count;
          },
          (error) => {
            console.log(error);
          }
      );
    },
    get_number() {
      var api = this.$api.api.interfacenew.get_number;
      this.$https.post({
            api: api,
            type: "formData",
          }, {
            id: this.id
          },
          (response) => {
            console.log(" response.data:", response.data)
            this.numberData = response.data
          },
          (error) => {
            // console.log(error);
          }
      );
    }
  },
  created: function () {

    this.id = this.$route.query.id;
    this.getdetail();
     this.get_number();
    // this.getlike();
    // this.getadv();
    this.getbrand()
    this.getqua()
    this.getnewlist();
    this.getpatent();//专利信息
    this.getpeoplelist();//主要人员
    this.getshare();//股东信息
    this.getchange();//变更记录
    this.getsoftright();//软件著作权
    this.getcopyright();//作品著作权

  }
}
</script>
<style scoped>
.margin-bottom-20 {
  margin-bottom: 20px;
}

.border-radius-10 {
  border-radius: 10px;
}

.box-shadow, .stack-card-view {
  box-shadow: 0 0 10px rgba(0, 0, 0, .2);
}

.hetext {
  font-size: 15px;
  color: #bdbdbd;
  padding: 16px 0;
  cursor: pointer;
}

input {
  height: 30px !important;
  line-height: 30px !important;
}


.company_logo img {
  width: 80px;
  height: 80px;
}


.oneleft img {
  width: 44px;
  max-height: 44px;
}


.oneright p {
  font-size: 14px;
  color: #292a2d;
  font-weight: 400;
  padding-bottom: 2px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
}

.oneright span {
  display: inline-block;
  padding: 2px 8px;
  font-size: 12px;
  color: #fff;
  font-weight: 400;
  background: #36a6f7;
  border-radius: 2px;
}


.oneleft1 img {
  width: 99px;
  height: 99px;
  border-radius: 10px;
}

.oneright1 p {
  font-size: 14px;
  color: #292a2d;
  font-weight: 400;
  padding-bottom: 2px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 214px;
}

.oneright1 span {
  display: inline-block;
  padding: 2px 8px;
  font-size: 12px;
  color: #fff;
  font-weight: 400;
  background: #36a6f7;
  border-radius: 2px;
}


td,
th {
  padding: 0;
}


.pure-table caption {
  color: #000;
  /* font: italic 85%/1 arial,sans-serif; */
  padding: 1em 0;
  text-align: center;
}

.pure-table td,
.pure-table th {
  border-left: 1px solid #cbcbcb;
  border-width: 0 0 0 1px;
  font-size: inherit;
  margin: 0;
  overflow: visible;
  padding: 1em 0.5em;
  vertical-align: middle;
}

.pure-table thead {
  background-color: #e0e0e0;
  color: #000;
  text-align: left;
  vertical-align: bottom;
}

.pure-table td {
  background-color: transparent;
}

.pure-table-bordered td {
  border-bottom: 1px solid #cbcbcb;
}

.pure-table-bordered tbody > tr:last-child > td {
  border-bottom-width: 0;
}


</style>

<style lang="scss" scoped>
@import './detailcss.scss';

.timetext {
  display: flex;
  align-items: center;
  font-size: 16px;
  color: #898993;

  .icon {
    width: 15px;
    height: 15px;
    margin-right: 5px
  }
}

.gray-tag {
  color: #898993;
  padding-left: 10px;
  font-size: 16px;

  span {
    margin-right: 10px
  }
}

</style>





// WEBPACK FOOTER //
// comdetail.vue?a4ffee8c